<template>
  <div class="settings-div" :class="getClass">
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: "SettingsContainer",
  props: {
    type: {
      type: String,
      validator: (type) => ["dark", "light", "inner"].includes(type),
    },
    isSession: Boolean,
  },
  computed: {
    getClass() {
      let classes = "";
      if (this.isSession) {
        classes = "session-settings-div";
      }
      if (this.type === "dark" || this.type === "light") {
        classes = classes + " " + this.type;
        return classes;
      }
      classes = classes + " " + "inner light";
      return classes;
    },
  },
};
</script>
<style scoped>
.settings-div {
  border-radius: 20px;
  padding: 4px 10px;
  border: 1px solid #dbdbdbbd;
  box-shadow: 0 0 0 1px rgb(15 15 15 / 5%), 0 3px 6px rgb(15 15 15 / 10%), 0 9px 24px rgb(213 213 213 / 20%);
  background-color: rgb(255 255 255 / 0.3);
  -webkit-backdrop-filter: blur(5px);
  backdrop-filter: blur(5px);
}
.dark {
  background-color: #f9f9f9c9;
  box-shadow: inset 0px -1px 4px 0px #eaeaeaab, inset 0px 1px 4px 0px #e2e2e29e;
}
.light {
  background-color: #ffffffc9;
  box-shadow: inset 0px -1px 4px 0px #f5f4f4ab, inset 0px 1px 4px 0px #f7f7f79e;
}
.inner {
  border-radius: 14px;
  padding: 20px 20px;
  margin-top: 26px;
  max-width: 700px;
  box-sizing: border-box;
}
.session-settings-div {
  margin-left: auto;
  margin-right: auto;
  width: 700px;
  border: unset;
  max-height: 480px;
  overflow-y: scroll;
  box-shadow: 0 1px 4px 0 hsl(0deg 0% 69% / 40%);
}
</style>
